@if (validURL()) {
  <section class="video-dialog" [class]="{ chat: show_chat }">
    @if (button_video) {
      <div class="play-button-container">
        @if (!is_error) {
          @if (shouldShowPlayButton) {
            <img class="play-button" src="assets/click3a.png" alt="play" />
          }
          <app-media-chrome-player [src]="videoSources"></app-media-chrome-player>
          <!-- <app-plyr
          class="video-button"
          [ngStyle]="{'display': ready ? 'block' : 'none'}"
          [plyrSources]="videoSources"
          [plyrOptions]="options"
          (plyrInit)="onReady($event)"
        ></app-plyr> -->
      }
      @if (!ready) {
        <app-loading-indicator></app-loading-indicator>
      }
    </div>
  } @else {
    @if (!skip) {
      <app-media-chrome-player [src]="videoSources"></app-media-chrome-player>
      <!-- <app-plyr id="video-ad-plyr" *ngIf="plyr && !skip" (plyrInit)="plyrInit($event)" style="position: relative" [plyrSources]="videoSources" [plyrOptions]="options">
      <div class="skip-ad-dialog-container" (click)="openAdSite()">
        <div class="host-url">
          <div>{{ getHostname(data.iframe_data.video_ad?.external_tap_url) }}</div>
          <img class="url-img" src="https://res.cloudinary.com/bleachr/image/upload/v1649886398/TennisONE/T1%20Icons/link_dark.png" alt="" />
        </div>
      </div>
      <app-skip-ad-dialog *ngIf="ready" (close_skip)="skipAd($event)" [skip_src]="skip_src" [plyrData]="plyr" [video_ad]="data.iframe_data.video_ad"></app-skip-ad-dialog>
    </app-plyr> -->
  } @else {
    <app-media-chrome-player [src]="videoSources"></app-media-chrome-player>
    <!-- <app-plyr *ngIf="skip" [plyrSources]="afterAdSource()" [plyrOptions]="options"></app-plyr> -->
  }
  <div id="progress-indicator" class="progress-indicator"></div>
}
@if (show_chat) {
  <app-chat-dialog [is_livestream]="true" [livestream_data]="subject"></app-chat-dialog>
}
</section>
}
@if (!validURL()) {
  <section class="video-dialog">
    <div class="video-error">Sorry, this video is unavailable.</div>
  </section>
}
